import { Loader, Text } from "@mantine/core";
import { useEffect, useState } from "react";
import type { Location } from "@/sales-tools/rapport-building/useRapportBuildingStore";
import { useTimezone } from "./api/useTimezone";
import { getLocationString } from "./getLocationString";

export type CustomerTimeProps = {
    location: Location;
};

export function CustomerTime({ location }: CustomerTimeProps) {
    const [time, setTime] = useState(new Date());
    const { data: timezone, isLoading: isTimezoneLoading } = useTimezone(getLocationString(location), {
        initialData: location.timezone,
    });

    useEffect(() => {
        const timeout = setTimeout(() => {
            setTime(new Date());
        }, 1000 - time.getMilliseconds());

        return () => clearTimeout(timeout);
    }, [time]);

    if (isTimezoneLoading) {
        return <Loader size="xs" color="dark.3" type="dots" />;
    }

    const formattedTime = time.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        timeZone: timezone,
    });

    if (timezone == null) {
        return null;
    }

    return (
        <Text fz="sm" c="dark.0">
            {` • ${formattedTime.toLocaleLowerCase()}`}
        </Text>
    );
}
